import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { baseUrl } from "../utils/OtherUtils";
import axios from "axios";
import Cookies from "js-cookie";
//import { useAuthContext } from "./AuthContext";

const AddressContext = createContext();

const AddressProvider = ({ children }) => {
  //const { handleNotification } = useAuthContext();
  const [addressData, setAddressData] = useState([]);
  const [addAddress, setAddAddress] = useState({
    type: "",
    house: "",
    area: "",
    pincode: "",
    state: "",
    city: "",
  });
  const [isAddAddress, setIsAddAddress] = useState(false);

  // Function to create a save address
  const addressSave = async (addressData) => {
    const url = `${baseUrl}/api/address/create-address`;

    try {
      // Retrieve the token and userId from cookies
      const token = Cookies.get("token");
      const userId = Cookies.get("userId");

      if (!token || !userId) {
        console.error("Missing authentication details.");
        return;
      }

      // Include userId in the address data
      const addressWithUserId = { ...addressData, userId };

      // Sending a POST request to create the address
      const response = await axios.post(url, addressWithUserId, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        getAddresses();
        setAddAddress({
          type: "",
          house: "",
          area: "",
          pincode: "",
          state: "",
          city: "",
        });
        setIsAddAddress(false);
      } else {
        console.error("Failed to create address:", response.data.message);
      }
    } catch (error) {
      console.error(
        "Error creating address:",
        error.response ? error.response.data : error.message
      );
    }
  };

  // Function to get all address
  const getAddresses = useCallback(async () => {
    const url = `${baseUrl}/api/address/get-address`;

    try {
      const token = Cookies.get("token");
      const userId = Cookies.get("userId");

      if (!token || !userId) {
        console.error("Missing authentication token.");
        return;
      }

      // Send the GET request with the Authorization header
      const response = await axios.get(url, {
        params: { userId }, // Pass userId as a query parameter
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        setAddressData(response.data.addresses);
      } else {
        console.error("Failed to fetch addresses:", response.data.message);
      }
    } catch (error) {
      console.error(
        "Error fetching addresses:",
        error.response ? error.response.data : error.message
      );
    }
  }, []);

  // Function to delete address
  const addressDelete = async (addressId) => {
    const url = `${baseUrl}/api/address/delete-address/${addressId}`;

    try {
      const token = Cookies.get("token");

      if (!token) {
        console.error("Missing authentication token.");
        return;
      }

      // Sending DELETE request with the Authorization header
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        getAddresses();
      } else {
        console.error("Failed to delete address:", response.data.message);
      }
    } catch (error) {
      console.error(
        "Error deleting address:",
        error.response ? error.response.data : error.message
      );
    }
  };

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");

    if (token && userId) {
      getAddresses();
    }
  }, []);

  return (
    <AddressContext.Provider
      value={{
        addressData,
        setAddressData,
        addressSave,
        addressDelete,
        addAddress,
        setAddAddress,
        getAddresses,
        isAddAddress,
        setIsAddAddress,
      }}
    >
      {children}
    </AddressContext.Provider>
  );
};

export const useAddressContext = () => useContext(AddressContext);

export default AddressProvider;
